const eurekoPonudbaTypes = {
    NacinPlacila: {
        SEPA: 'SEPA',
        UPN: 'UPN'
    },

    FrekvencaPlacila: {
        MESECNO: 'MESECNO',
        LETNO: 'LETNO'
    },

    ProduktBDCA: {
        STANDARD: 'Standard',
        PREMIUM: 'Premium'
    },

    ProduktBDBasic: {
        INDIVIDUALNI: 'Individualni',
        DRUZINSKI: 'Družinski'
    },

    RazmerjeZZavarovalcem: {
        ZAVAROVALEC: 'A',
        ZAKONEC: 'B',
        VZDRZEVAN_DRUZINSKI_CLAN: 'C',
        DRUGO: 'D'
    }
};

module.exports = {
    eurekoPonudbaTypes
};